// @flow

/**
 * Module dependencies.
 */

import { getPageUrlWithouLanguage, getPathname, getUrlBasedOnLanguage, getUrlsByKey } from 'core/utils';
import { includes } from 'lodash';
import { pages } from 'core/entities';
import createHistory from 'history/createBrowserHistory';
import i18n from 'client/translations/i18n';

/**
 * Variables constants.
 */

const history = createHistory();

/**
 * Get localized url.
 */

export function getLocalizedUrl(urlKey: string) {
  return getUrlBasedOnLanguage(urlKey, i18n.language);
}

/**
 * Is localized url active.
 */

export function isLocalizedUrlActive(urlKey: string, pathname: string) {
  return includes(getUrlsByKey(urlKey), pathname);
}

/**
 * Get localized routes.
 */

export function getLocalizedRoutes(routes: Array<Object>, language: string) {
  return routes.reduce((generatedRoutes, { component, pageKey }) => {
    const path = pages[pageKey][language];

    return [
      ...generatedRoutes,
      { component, language, path }
    ];
  }, []);
}

/**
 * Push route.
 */

export function pushRoute(language: string, pathname: string) {
  const urlPath = getPageUrlWithouLanguage(pathname, language);
  const path = getPathname(urlPath, language);

  history.push(path);
}



// WEBPACK FOOTER //
// ../src/client/core/utils/routes.js